import { render, staticRenderFns } from "./OpenDoorFailed.vue?vue&type=template&id=452e7bca&scoped=true&"
import script from "./OpenDoorFailed.vue?vue&type=script&lang=js&"
export * from "./OpenDoorFailed.vue?vue&type=script&lang=js&"
import style0 from "./OpenDoorFailed.vue?vue&type=style&index=0&id=452e7bca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452e7bca",
  null
  
)

export default component.exports